import { render } from "./form-input.vue?vue&type=template&id=19f8d23c&lang=pug"
import script from "./form-input.vue?vue&type=script&lang=js"
export * from "./form-input.vue?vue&type=script&lang=js"

import exportComponent from "C:\\m-tech\\WMExtranet2.0\\WebUI\\WiseApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__